import React, { useEffect, useState } from 'react';
import { HomeIcon, UserIcon, ShieldIcon, AwardIcon, ClipboardListIcon, CalendarIcon, MailIcon } from 'lucide-react';
export function MobileScrollIndicator() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const [isVisible, setIsVisible] = useState(false);
  const sections = [{
    id: 'home',
    label: 'Home',
    icon: <HomeIcon className="w-4 h-4" data-id="element-335" />
  }, {
    id: 'about',
    label: 'Over mij',
    icon: <UserIcon className="w-4 h-4" data-id="element-336" />
  }, {
    id: 'services',
    label: 'Diensten',
    icon: <ShieldIcon className="w-4 h-4" data-id="element-337" />
  }, {
    id: 'qualifications',
    label: 'Kwalificaties',
    icon: <AwardIcon className="w-4 h-4" data-id="element-338" />
  }, {
    id: 'experience',
    label: 'Ervaring',
    icon: <ClipboardListIcon className="w-4 h-4" data-id="element-339" />
  }, {
    id: 'availability',
    label: 'Tarieven',
    icon: <CalendarIcon className="w-4 h-4" data-id="element-340" />
  }, {
    id: 'contact-new',
    label: 'Contact',
    icon: <MailIcon className="w-4 h-4" data-id="element-341" />
  }];
  useEffect(() => {
    // Get all section elements
    const sectionElements = sections.map(section => ({
      id: section.id,
      ref: document.getElementById(section.id)
    })).filter(section => section.ref);
    // Calculate total scrollable height
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollableHeight = documentHeight - windowHeight;
    // Handle scroll events
    const handleScroll = () => {
      // Calculate scroll progress percentage
      const scrollY = window.scrollY;
      const progress = Math.min(Math.max(scrollY / scrollableHeight, 0), 1);
      setScrollProgress(progress * 100);
      // Determine active section
      const scrollPosition = scrollY + windowHeight / 3;
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const section = sectionElements[i];
        if (section.ref && section.ref.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
      // Show indicator when scrolling starts, hide after scrolling stops
      setIsVisible(true);
      clearTimeout(window.scrollTimeout);
      window.scrollTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 2000);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(window.scrollTimeout);
    };
  }, []);
  // Find the index of the active section
  const activeSectionIndex = sections.findIndex(section => section.id === activeSection);
  // Scroll to section when clicking on a section indicator
  const scrollToSection = id => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  };
  return <div className={`lg:hidden fixed top-0 left-0 right-0 z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-342">
      {/* Main progress bar */}
      <div className="h-1 bg-gray-700 w-full" data-id="element-343">
        <div className="h-full bg-orange-500 transition-all duration-200 ease-out" style={{
        width: `${scrollProgress}%`
      }} data-id="element-344"></div>
      </div>
      {/* Section indicator */}
      <div className="bg-gray-800 bg-opacity-90 backdrop-blur-sm border-b border-gray-700 px-4 py-2 flex items-center justify-between" data-id="element-345">
        <div className="flex items-center gap-2" data-id="element-346">
          <div className="p-1.5 bg-orange-500 rounded-full" data-id="element-347">
            {sections[activeSectionIndex]?.icon}
          </div>
          <span className="text-sm font-medium" data-id="element-348">
            {sections[activeSectionIndex]?.label}
          </span>
        </div>
        {/* Section dots */}
        <div className="flex items-center gap-1.5" data-id="element-349">
          {sections.map((section, index) => <button key={section.id} onClick={() => scrollToSection(section.id)} className={`w-2 h-2 rounded-full transition-all ${index === activeSectionIndex ? 'bg-orange-500 scale-125' : index < activeSectionIndex ? 'bg-gray-400' : 'bg-gray-600'}`} aria-label={`Scroll to ${section.label}`} data-id="element-350" />)}
        </div>
      </div>
    </div>;
}